exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thin-banner--padding-top[data-v-4fa92218] {\n    padding-top: 20px;\n}\n.thin-banner--padding-bottom[data-v-4fa92218] {\n    padding-bottom: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fa92218","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/valuation-tool/components/Sections/ThinBanner.vue
// module id = vejS
// module chunks = 1 2 4 5 15 17 18 19